import Vue from 'vue'
import Router from 'vue-router'
import App from '../App'

// index
const index = () => import('@/pages/index/index')
const home = () => import('@/pages/index/home/home')
const courseWare = () => import('@/pages/index/courseware/courseware')
const detail = () => import('@/pages/index/detail/detail')
const video = () => import('@/pages/index/video/video')
const member = () => import('@/pages/index/member/member')
const community = () => import('@/pages/index/community/community')

// detail
const article = () => import('@/pages/detail/article/article')
const post = () => import('@/pages/detail/post/post')

// member下
const friend = () => import('@/pages/friend/friend')
const homepage = () => import('@/pages/index/member/homepage/homepage')
const follow = () => import('@/pages/index/member/follow/follow')
const circle = () => import('@/pages/index/member/circle/circle')
const myPosts = () => import('@/pages/index/member/myPosts/myPosts')
const collection = () => import('@/pages/index/member/collection/collection')
const news = () => import('@/pages/index/member/news/news')
const rewardDetailed = () => import('@/pages/index/member/rewardDetailed/rewardDetailed')
const setting = () => import('@/pages/index/member/setting/setting')
const opinion = () => import('@/pages/index/member/opinion/opinion')
const comment = () => import('@/pages/index/member/news/comment/comment')
const consumption = () => import('@/pages/index/member/news/consumption/consumption')
const fabulous = () => import('@/pages/index/member/news/fabulous/fabulous')
const friends = () => import('@/pages/index/member/news/friends/friends')
const account = () => import('@/pages/index/member/setting/account/account')
const software = () => import('@/pages/index/member/setting/software/software')
const address = () => import('@/pages/index/member/setting/address/address')
const mianze = () => import('@/pages/index/member/setting/software/mianze/mianze')
const material = () => import('@/pages/index/member/homepage/material/material')
const binding = () => import('@/pages/index/member/homepage/material/binding/binding')
const bindingNew = () => import('@/pages/index/member/homepage/material/bindingNew/bindingNew')
const modifyName = () => import('@/pages/index/member/homepage/material/modifyName/modifyName')
const wallet = () => import('@/pages/index/member/wallet/wallet')
const assets = () => import('@/pages/index/member/assets/assets')
const sign = () => import('@/pages/index/member/sign/sign')
const grade = () => import('@/pages/index/member/grade/grade')
const rewardRule = () => import('@/pages/index/member/grade/rewardRule/rewardRule')
const assetDetailed = () => import('@/pages/index/member/wallet/assetDetailed/assetDetailed')
const modifyAutograph = () => import('@/pages/index/member/homepage/material/modifyAutograph/modifyAutograph')
const addressIndex = () => import('@/pages/index/member/homepage/material/addressIndex/addressIndex')
const dataEdit = () => import('@/pages/index/member/homepage/material/dataEdit/dataEdit')
const myFans = () => import('@/pages/index/member/homepage/myFans/myFans')
const fans = () => import('@/pages/friend/fans/fans')
const chatDetail = () => import('@/pages/chat/detail/detail')
const loginPassword = () => import('@/pages/index/member/setting/account/loginPassword/loginPassword')
const modifyAddress = () => import('@/pages/modifyAddress/modifyAddress')

// 其它
const playVideo = () => import('@/pages/playVideo/playVideo')
const tagThem = () => import('@/pages/tagThem/tagThem')
const detailsTheme = () => import('@/pages/detailsTheme/detailsTheme')
const chat = () => import('@/pages/chat/chat')
const login = () => import('@/pages/login/login')
const loginMessage = () => import('@/pages/loginMessage/loginMessage')
const userReport = () => import('@/pages/userReport/userReport')
const error = () => import('@/pages/error/error')
const postReport = () => import('@/pages/postReport/postReport')
const adIndex = () => import('@/pages/ad/ad')
const todayHot = () => import('@/pages/todayHot/todayHot')
const theme = () => import('@/pages/theme/theme')
const myTheme = () => import('@/pages/myTheme/myTheme')
const newTheme = () => import('@/pages/newTheme/newTheme')
const moneyRecharge = () => import('@/pages/moneyRecharge/moneyRecharge')
const recharge = () => import('@/pages/recharge/recharge')
const articleLabel = () => import('@/pages/articleLabel/articleLabel')
const articleLabels = () => import('@/pages/articleLabel/articleLabels')
const homeArticleLabel = () => import('@/pages/homeArticleLabel/homeArticleLabel')

// 发布
const releaseCharacters = () => import('@/pages/release/releaseCharacters')
const releaseMessage = () => import('@/pages/release/releaseMessage')
const releaseTinyVideo = () => import('@/pages/release/releaseTinyVideo')
const releaseVideo = () => import('@/pages/release/releaseVideo')

// 商城
const shop = () => import('@/pages/shop/shop')
const myOrders = () => import('@/pages/shop/myOrders/myOrders')
const details = () => import('@/pages/shop/details/details')
const orderSee = () => import('@/pages/shop/orderSee/orderSee')
const recharegePayment = () => import('@/pages/shop/rechargePayment/rechargePayment')
const orderSubmit = () => import('@/pages/shop/orderSubmit/orderSubmit')

// 搜索
const search = () => import('@/pages/search/search')
const searchUser = () => import('@/pages/search/searchUser')
const searchArticle = () => import('@/pages/search/searchArticle')
const searchTopic = () => import('@/pages/search/searchTopic')

// 注册
const register = () => import('@/pages/register/register')
const registerOne = () => import('@/pages/register/registerOne')
const registerTwo = () => import('@/pages/register/registerTwo')
const bindPhone = () => import('@/pages/bindPhone/bindPhone')
const bindPhoneOne = () => import('@/pages/bindPhone/bindPhoneOne')

// 忘记密码
const forgetPassword = () => import('@/pages/forgetPassword/forgetPassword')
const forgetPasswordOne = () => import('@/pages/forgetPassword/forgetPasswordOne')

// about
const termsOfService = () => import('@/pages/about/termsOfService')
const privacyPolicy = () => import('@/pages/about/privacyPolicy')

// 格律
const PoetryRules = () => import('@/pages/poetryRules/poetryRules')
const PoetryBody = () => import('@/pages/poetryRules/poetryBody')
const PoetryType = () => import('@/pages/poetryRules/poetryType')
const PoetryContent = () => import('@/pages/poetryRules/poetryContent')
const PoetryDetail = () => import('@/pages/poetryRules/poetryDetail')
const MetricalContent = () => import('@/pages/poetryRules/metricalContent')
const CentralMusic = () => import('@/pages/poetryRules/centerMusic')
const FlatMusic = () => import('@/pages/poetryRules/flatMusic')
const FlatMusicDetail = () => import('@/pages/poetryRules/flatMusicDetail')
const CiMusic = () => import('@/pages/poetryRules/ciMusic')
const CiMusicDetail = () => import('@/pages/poetryRules/ciMusicDetail')
const ChinaiMusic = () => import('@/pages/poetryRules/chinaMusic')
const ChinaiMusicDetail = () => import('@/pages/poetryRules/chinaMusicDetail')
const Sidetail = () => import('@/pages/poetryRules/sidetail')
const CenterMusicDetail = () => import('@/pages/poetryRules/centerMusicDetail')
const CiDetail = () => import('@/pages/poetryRules/ciDetail')
const TestInput = () => import('@/pages/poetryRules/testInput')
Vue.use(Router)
export default new Router({
  // scrollBehavior (to, from, savedPosition) {
  //   if (to.name === 'index' || to.name === 'community' || to.name === 'video' || to.name === 'member') {
  //     let scroll = 0
  //     if (document.documentElement && document.documentElement.scrollTop) {
  //       scroll = document.documentElement.scrollTop
  //     } else {
  //       scroll = document.body.scrollTop
  //     }
  //     if (from.name === 'index' || from.name === 'community' || from.name === 'video' || from.name === 'member') {
  //       sessionStorage.setItem(from.name, scroll)
  //     }
  //     if (sessionStorage.getItem(to.name)) {
  //       return {x: 0, y: parseInt(sessionStorage.getItem(to.name))}
  //     } else {
  //       return {x: 0, y: 0}
  //     }
  //   }
  //   return {x: 0, y: 0}
  // },
  routes: [
    {
      name: 'grade',
      path: '/member/grade',
      component: grade
    },
    {
      name: 'rewardRule',
      path: '/member/grade/rewardRule',
      component: rewardRule
    },
    {
      name: 'homepage',
      path: '/member/homepage',
      component: homepage
    },
    {
      name: 'material',
      path: '/member/material',
      component: material
    },
    {
      name: 'binding',
      path: '/member/binding',
      component: binding
    },
    {
      name: 'bindingNew',
      path: '/member/binding-new',
      component: bindingNew
    },
    {
      name: 'modifyName',
      path: '/member/modify-name',
      component: modifyName
    },
    {
      name: 'modifyAutograph',
      path: '/member/modify-autograph',
      component: modifyAutograph
    },
    {
      name: 'addressIndex',
      path: '/member/addressIndex',
      component: addressIndex
    },
    {
      name: 'dataEdit',
      path: '/member/data-edit',
      component: dataEdit
    },
    {
      name: 'myFans',
      path: '/member/my-fans',
      component: myFans
    },
    {
      name: 'follow',
      path: '/member/follow',
      component: follow
    },
    {
      name: 'circle',
      path: '/member/circle',
      component: circle
    },
    {
      name: 'myPosts',
      path: '/member/myPosts',
      component: myPosts
    },
    {
      name: 'collection',
      path: '/member/collection',
      component: collection
    },
    {
      name: 'news',
      path: '/member/news',
      component: news
    },
    {
      name: 'fabulous',
      path: '/member/fabulous',
      component: fabulous
    },
    {
      name: 'comment',
      path: '/member/comment',
      component: comment
    },
    {
      name: 'friends',
      path: '/member/friends',
      component: friends
    },
    {
      name: 'consumption',
      path: '/member/consumption',
      component: consumption
    },
    {
      name: 'rewardDetailed',
      path: '/member/rewardDetailed',
      component: rewardDetailed
    },
    {
      name: 'setting',
      path: '/member/setting',
      component: setting
    },
    {
      name: 'account',
      path: '/member/account',
      component: account
    },
    {
      name: 'loginPassword',
      path: '/member/login-password',
      component: loginPassword
    },
    {
      path: '/member/binding',
      component: binding
    },
    {
      name: 'software',
      path: '/member/software',
      component: software
    },
    {
      name: 'mianze',
      path: '/member/mianze',
      component: mianze
    },
    {
      name: 'address',
      path: '/member/address',
      component: address
    },
    {
      name: 'opinion',
      path: '/member/opinion',
      component: opinion
    },
    {
      name: 'assets',
      path: '/member/assets',
      component: assets
    },
    {
      name: 'wallet',
      path: '/member/wallet',
      component: wallet
    },
    {
      name: 'assetDetailed',
      path: '/member/asset-detailed',
      component: assetDetailed
    },
    {
      name: 'rewardDetailed',
      path: '/member/reward-detailed',
      component: rewardDetailed
    },
    {
      name: 'sign',
      path: '/member/sign',
      component: sign
    },
    {
      name: 'home',
      path: '/home',
      // meta: {
      //   requireAuth: true
      // },
      component: home
    },
    {
      name: 'community',
      path: '/community',
      component: community
    },
    {
      path: '',
      redirect: '/index/home',
      component: App,
      children: [
      // index
        {
          name: 'index',
          path: '/index',
          component: index,
          redirect: '/index/home',
          children: [
            {
              name: 'home',
              path: 'home',
              // meta: {
              //   requireAuth: true
              // },
              component: home
            },
            {
              name: 'courseWare',
              path: 'courseWare',
              component: courseWare
            },
            {
              name: 'detail',
              path: 'detail',
              component: detail
            },
            {
              name: 'video',
              path: 'video',
              component: video
            },
            {
              name: 'community',
              path: 'community',
              component: community
            },
            {
              name: 'member',
              path: 'member',
              component: member
              // meta: {
              //   requireAuth: true
              // },
            }
          ]
        },
      // 商城
        {
          name: 'shop',
          path: '/shop',
          component: shop,
          children: [
            {
              name: 'myOrders',
              path: 'my-orders',
              component: myOrders,
              // meta: {
              //   requireAuth: true
              // }
            },
            {
              name: 'orderSee',
              path: 'order-see',
              component: orderSee,
              // meta: {
              //   requireAuth: true
              // }
            },
            {
              name: 'rechargePayment',
              path: 'recharge-payment',
              component: recharegePayment,
              // meta: {
              //   requireAuth: true
              // }
            },
            {
              name: 'details',
              path: 'details',
              component: details
            },
            {
              name: 'orderSubmit',
              path: 'order-submit',
              component: orderSubmit,
              // meta: {
              //   requireAuth: true
              // }
            },
            {
              name: 'assets',
              path: 'assets',
              component: assets,
              // meta: {
              //   requireAuth: true
              // }
            }
          ]
        },
        // detail
        {
          name: 'article',
          path: '/article',
          component: article
        },
        {
          name: 'post',
          path: '/post',
          component: post
        },
        // 其它
        {
          name: 'friend',
          path: '/friend',
          component: friend,
          children: [
            {
              name: 'fans',
              path: 'fans',
              component: fans
            }
          ]
        },
        {
          name: 'playVideo',
          path: '/play-video',
          component: playVideo
        },
        {
          name: 'tagTheme',
          path: '/tag-theme',
          component: tagThem
        },
        {
          name: 'detailsTheme',
          path: '/details-theme',
          component: detailsTheme
        },
        {
          name: 'releaseCharacters',
          path: '/release-characters',
          component: releaseCharacters,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'releaseThemMessage',
          path: '/release-them-message',
          component: releaseMessage,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'releaseMessage',
          path: '/release-message',
          component: releaseMessage,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'releaseTinyVideo',
          path: '/release-tinyVideo',
          component: releaseTinyVideo,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'releaseVideo',
          path: '/release-video',
          component: releaseVideo,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'chat',
          path: '/chat',
          component: chat,
          // meta: {
          //   requireAuth: true
          // },
          children: [
            {
              name: 'detail',
              path: 'detail',
              component: chatDetail
            }
          ]
        },
        {
          name: 'login',
          path: '/login',
          component: login
        },
        {
          name: 'loginMessage',
          path: '/login-message',
          component: loginMessage
        },
        {
          name: 'search',
          path: 'search',
          component: search
        },
        {
          name: 'searchUser',
          path: 'search-user',
          component: searchUser
        },
        {
          name: 'searchTopic',
          path: 'search-topic',
          component: searchTopic
        },
        {
          name: 'searchArticle',
          path: 'search-article',
          component: searchArticle
        },
        {
          path: 'address',
          component: address
        },
        {
          name: 'userReport',
          path: 'user-report',
          component: userReport,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'error',
          path: 'error',
          component: error,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'postReport',
          path: 'post-report',
          component: postReport,
          // meta: {
          //   requireAuth: true
          // }
        },
        // 广告
        {
          path: '/adindex/:url/:title',
          component: adIndex
        },
        // 格律
        {
          name: 'poetryRules',
          path: '/poetryRules',
          component: PoetryRules
        },
        {
          name: 'poetryBody',
          path: '/poetryBody',
          component: PoetryBody
        },
        {
          name: 'poetryType',
          path: '/poetryType',
          component: PoetryType
        },
        {
          name: 'poetryContent',
          path: '/poetryContent',
          component: PoetryContent
        },
        {
          name: 'poetryDetail',
          path: '/poetryDetail/:name',
          component: PoetryDetail
        },
        {
          name: 'metricalContent',
          path: '/metricalContent',
          component: MetricalContent
        },
        {
          name: 'centralMusic',
          path: '/centralMusic',
          component: CentralMusic
        },
        {
          name: 'flatMusic',
          path: '/flatMusic',
          component: FlatMusic
        },
        {
          name: 'flatMusicDetail',
          path: '/flatMusicDetail',
          component: FlatMusicDetail
        },
        {
          name: 'ciMusic',
          path: '/ciMusic',
          component: CiMusic
        },
        {
          name: 'ciMusicDetail',
          path: '/ciMusicDetail',
          component: CiMusicDetail
        },
        {
          name: 'chinaMusic',
          path: '/chinaMusic',
          component: ChinaiMusic
        },
        {
          name: 'testInput',
          path: '/testInput',
          component: TestInput
        },
        {
          name: 'chinaMusicDetail',
          path: '/chinaMusicDetail',
          component: ChinaiMusicDetail
        },
        {
          name: 'siDetail',
          path: '/siDetail',
          component: Sidetail
        },
        {
          name: 'centerMusicDetail',
          path: '/centerMusicDetail',
          component: CenterMusicDetail
        },
        {
          name: 'ciDetail',
          path: '/ciDetail',
          component: CiDetail
        },
        // 注册
        {
          name: 'register',
          path: '/register',
          component: register
        },
        {
          name: 'registerOne',
          path: '/register-one',
          component: registerOne
        },
        {
          name: 'registerTwo',
          path: '/register-two',
          component: registerTwo
        },
        {
          name: 'bindPhone',
          path: 'bind-phone',
          component: bindPhone
        },
        {
          name: 'bindPhoneOne',
          path: 'bind-phone-one',
          component: bindPhoneOne
        },
        // 忘记密码
        {
          name: 'forgetPassword',
          path: 'forget-password',
          component: forgetPassword
        },
        {
          name: 'forgetPasswordOne',
          path: 'forget-password-one',
          component: forgetPasswordOne
        },
        // about
        {
          name: 'termsOfService',
          path: 'terms-of-service',
          component: termsOfService
        },
        {
          name: 'privacyPolicy',
          path: 'privacy-policy',
          component: privacyPolicy
        },
        {
          name: 'todayHot',
          path: 'today-hot',
          component: todayHot
        },
        {
          name: 'theme',
          path: 'theme',
          component: theme
        },
        {
          name: 'newTheme',
          path: 'new-theme',
          component: newTheme
        },
        {
          name: 'myTheme',
          path: 'my-theme',
          component: myTheme,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'moneyRecharge',
          path: '/money-recharge',
          component: moneyRecharge,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'recharge',
          path: '/recharge',
          component: recharge,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          path: '/modify-address',
          component: modifyAddress,
          // meta: {
          //   requireAuth: true
          // }
        },
        {
          name: 'articleLabel',
          path: '/article-label',
          component: articleLabel
        },
        {
          name: 'articleLabels',
          path: '/article-labels',
          component: articleLabels
        },
        {
          name: 'homeArticleLabel',
          path: '/homeArticle-label',
          component: homeArticleLabel
        }
      ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js